import { SectionHeading } from "@/components/shared/SectionHeading";
import { Reveal } from "@/components/shared/Reveal";

export const BrokerProblem = () => (
  <section data-testid="broker-problem-section" className="py-24 md:py-28 bg-white">
    <div className="max-w-3xl mx-auto px-5 md:px-8 text-center">
      <SectionHeading
        eyebrow="The Problem"
        title="When You Have the Load, Finding the Right Driver Shouldn't Slow You Down."
        align="center"
        testId="broker-problem"
      />
      <Reveal delay={0.2}>
        <p className="mt-6 text-rr-muted text-base md:text-lg leading-relaxed">
          Brokerages frequently manage changing capacity requirements, driver availability, and time-sensitive transportation opportunities. RelayRigs is building infrastructure designed to make driver access easier. Instead of rebuilding a contact list for every opportunity, brokers can develop a private network inside RelayRigs.
        </p>
      </Reveal>
    </div>
  </section>
);
